import cs from 'classnames';
import React from 'react';
import { slugs, useRentalSteps } from '../../app/steps';
import { bsClasses } from 'shared/bootstrap';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { NextLink } from 'shared/components/SubmitButtons';
import { Welcome_ApplicationFragment, Welcome_PortalFragment } from '../../generated.graphql';
import { RentalStepProps } from 'rental/app/steps';
import styles from './Welcome.module.scss';


interface Props extends RentalStepProps {
  portal: Welcome_PortalFragment;
  application: Welcome_ApplicationFragment;
}

/** 
 * Whilst this appears to handle multiple portals, it's only designed to work with studio19-in-store
*/
export const Welcome = (props: Props) => {
  const {portal, application: {inStore}} = props
  const steps = useRentalSteps({slug: slugs.welcome});

  return (
    <div className={cs(bsClasses.container, '')}>
      <RentalPageTitleHelmet>Welcome</RentalPageTitleHelmet>

      <p className={cs(styles.RentalCompany, 'my-5 font-weight-normal')}>
        <span>&nbsp;&nbsp;Hello, welcome to</span>
        {portal.portalLogoUrl ? 
          <img src={portal.portalLogoUrl} alt={portal.title} title={portal.title} className="img-fluid"/>
          :
          portal.title
        }
      </p>

      <div className={cs("text-center mb-5")}>
        {inStore &&
          <>
            <p className="font-weight-normal">
              You've been sent this rental
              <br/>
              application by
              {inStore.salesPersonName && <> {inStore.salesPersonName} at </>}
            </p>
            <div className="font-weight-normal my-4">
              {inStore.storeLogo ? 
                <div className={cs(styles.StoreLogo)}>
                  <img src={inStore.storeLogo} alt={inStore.storeName} title={inStore.storeName} className={cs("img-fluid")}/>
                </div>
                :
                inStore.storeName
              }
            </div>
          </>
        }
        <p className="font-weight-normal my-4">Follow Your Passion Everyday</p>
        <p className="mb-1">Studio 19 Rental Benefits:</p>
        <p className="text-muted">
          Apply To Buy Any Time<br/>
          Low Monthly Payments<br/>
          Return Any Time After 6 Months<br/>
          Optional Protection Plan Available<br/>
        </p>
        <div>
        </div>
      </div>

      {steps.next && <NextLink to={steps.next?.link} className={cs(styles.NextLink, 'my-5')}>
        View Your Application
      </NextLink>}
    </div>
  )
}
